module.exports = __webpack_public_path__ + "img/boots-icon.3a909af4.png";